import { render, staticRenderFns } from "./PoolContributionDetails.vue?vue&type=template&id=1a4cc918"
import script from "./PoolContributionDetails.vue?vue&type=script&lang=js"
export * from "./PoolContributionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports